import { NavLink, Outlet } from "react-router-dom";

import type { UserSession } from "../lib/trpc";

export function PurchasingLayout({ session }: { session: UserSession }) {
  const canManage = session.membership.role !== "collaborator";
  const tabs = [
    { to: "/acquisti/richieste", label: "Richieste" },
    ...(canManage
      ? [
          { to: "/acquisti/fornitori", label: "Fornitori" },
          { to: "/acquisti/confronto", label: "Confronto prezzi" },
          { to: "/acquisti/ordini", label: "Ordini" },
          { to: "/acquisti/riepilogo", label: "Riepilogo" },
        ]
      : []),
  ];

  return (
    <main className="page purchase-area">
      <nav className="purchase-tabs" aria-label="Sezioni acquisti">
        {tabs.map((tab) => (
          <NavLink key={tab.to} to={tab.to}>{tab.label}</NavLink>
        ))}
      </nav>
      <Outlet />
    </main>
  );
}
